<script setup lang="ts">
import OCardsAndTemplates from '~/components/organisms/CardsAndTemplates.vue'
import { CardType } from '~/static/enums/card-type'

useSeoMeta({
  title: 'Шаблоны для инфографики товаров на маркетплейсах – Magvi',
  description: 'Десятки бесплатных шаблонов для разных товаров на Wildberries, Ozon и Яндекс.Маркет',
})

useHead({
  link: [
    {
      rel: 'canonical',
      href: useRuntimeConfig().public.appUrl + '/templates',
    },
  ],
})

</script>

<template>
  <OCardsAndTemplates :type="CardType.Template" />
</template>
